/**
 * DeliveryMethodChip — the delivery-mode indicator shown next to the delivery
 * date. STANDARD renders a chip (standardDelTruck.svg + "STANDARD"); RUSH /
 * PRIORITY render the shared rushDeliveryTagIcon.svg badge (which already
 * carries its own label). Reusable across PDP and Cart.
 */
import React, { FC } from 'react';
import classNames from 'classnames/bind';
import properties from '../../../modules/ajio-util/properties';
import { DELIVERY_METHOD, DeliveryMethod } from './constants';
import styles from './index.pcss';

const cx = classNames.bind(styles);
const imageBaseUrl = properties.getProperty('imageBaseUrl');
const standardDeliveryTruckImg = `${imageBaseUrl}/static/img/standardDelTruck.svg`;
const rushDeliveryTagIcon = `${imageBaseUrl}/static/img/rushDeliveryTagIcon.svg`;
const priorityDeliveryTagIcon = `${imageBaseUrl}/static/img/priority_delivery_sla.svg`;
// Ajiogram (fleek) dark-theme standard-delivery chip.
const standardDeliveryTruckAjiogram =
  'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/SD_AJIOGRAM_ICON.svg';

interface DeliveryMethodChipProps {
  method: DeliveryMethod;
  fleek?: boolean;
}

const LABEL: Record<DeliveryMethod, string> = {
  [DELIVERY_METHOD.STANDARD]: 'STANDARD',
  [DELIVERY_METHOD.RUSH]: 'RUSH',
  [DELIVERY_METHOD.PRIORITY]: 'PRIORITY'
};

const DeliveryMethodChip: FC<DeliveryMethodChipProps> = ({ method, fleek = false }) => {
  const isExpress = method === DELIVERY_METHOD.RUSH || method === DELIVERY_METHOD.PRIORITY;

  // Express uses a pre-labelled tag asset (PRIORITY / RUSH), rendered on its own.
  if (isExpress) {
    const expressIcon =
      method === DELIVERY_METHOD.PRIORITY ? priorityDeliveryTagIcon : rushDeliveryTagIcon;
    return (
      <img
        className={cx('method-chip__express-icon')}
        src={expressIcon}
        alt={`${LABEL[method]} delivery`}
      />
    );
  }

  return <img src={fleek ? standardDeliveryTruckAjiogram : standardDeliveryTruckImg} alt="" />;
};

export default DeliveryMethodChip;
